import { render, staticRenderFns } from "./CoberturaManual.vue?vue&type=template&id=e5d27956&scoped=true"
import script from "./CoberturaManual.vue?vue&type=script&lang=js"
export * from "./CoberturaManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d27956",
  null
  
)

export default component.exports